
import { MonthlyReport } from "../components/Manager/MonthlyReport";

const MonthlyReportPage = () => {
  return <MonthlyReport />;
};

export default MonthlyReportPage;
